/* src/app/modules/display/components/menus/print-menu/print-menu-sections-container/print-menu-sections-container.component.scss */
:host {
  display: block;
}
/*# sourceMappingURL=print-menu-sections-container.component.css.map */
